import React from 'react';

export default function HorseTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="23.46,11.97 15.59,11.97 13.93,5.58 21.79,5.58" fill="#C0A7C0" />
      <polygon points="15.59,11.97 23.46,11.97 22.34,15.12 14.48,15.12" fill="#956B95" opacity="0.95" />
      <polygon points="15.59,11.97 14.48,15.12 12.81,8.73 13.93,5.58" fill="#956B95" opacity="0.95" />
      <polygon points="25.5,8.03 15.02,8.03 13.45,2.0 23.93,2.0" fill="#C0A7C0" />
      <polygon points="15.02,8.03 25.5,8.03 23.93,12.48 13.45,12.48" fill="#956B95" opacity="0.95" />
      <polygon points="15.02,8.03 13.45,12.48 11.88,6.46 13.45,2.0" fill="#956B95" opacity="0.95" />
      <polygon points="28.12,30.33 17.77,30.33 17.77,14.61 28.12,14.61" fill="#C0A7C0" />
      <polygon points="17.77,30.33 28.12,30.33 24.98,28.76 14.63,28.76" fill="#956B95" opacity="0.95" />
      <polygon points="17.77,30.33 14.63,28.76 14.63,13.04 17.77,14.61" fill="#956B95" opacity="0.95" />
      <polygon points="28.12,34.27 17.77,34.27 17.77,30.33 28.12,30.33" fill="#C0A7C0" />
      <polygon points="17.77,34.27 28.12,34.27 24.98,32.69 14.63,32.69" fill="#956B95" opacity="0.95" />
      <polygon points="17.77,34.27 14.63,32.69 14.63,28.76 17.77,30.33" fill="#956B95" opacity="0.95" />
      <polygon points="26.49,38.0 18.62,38.0 18.62,30.14 26.49,30.14" fill="#C0A7C0" />
      <polygon points="18.62,38.0 26.49,38.0 24.13,36.82 16.26,36.82" fill="#956B95" opacity="0.95" />
      <polygon points="18.62,38.0 16.26,36.82 16.26,28.96 18.62,30.14" fill="#956B95" opacity="0.95" />
      <polygon points="26.49,38.0 18.62,38.0 18.62,30.14 26.49,30.14" fill="#C0A7C0" />
      <polygon points="18.62,38.0 26.49,38.0 24.13,36.82 16.26,36.82" fill="#956B95" opacity="0.95" />
      <polygon points="18.62,38.0 16.26,36.82 16.26,28.96 18.62,30.14" fill="#956B95" opacity="0.95" />
    </svg>
  );
}
